<template>
  <q-dialog v-model="model">
    <q-card style="min-width: 200px; max-width: 600px">
      <q-toolbar>
        <q-toolbar-title>{{ $t('leads.title') }}</q-toolbar-title>
        <q-btn icon="close" flat round dense v-close-popup />
      </q-toolbar>

      <q-card-section>
        <q-form @submit="onSubmit" class="q-gutter-y-sm">
          <div class="row q-col-gutter-sm">
            <q-input
              v-model="form.first_name"
              :label="$t('leads.firstName') + ' *'"
              class="col-12 col-sm-6"
              rounded
              dense
              outlined
              :rules="[(val) => !!val || $t('leads.required')]"
            />
            <q-input
              v-model="form.last_name"
              :label="$t('leads.lastName') + ' *'"
              class="col-12 col-sm-6"
              rounded
              dense
              outlined
              :rules="[(val) => !!val || $t('leads.required')]"
            />
          </div>

          <q-input
            v-model="form.email"
            :label="$t('leads.email') + ' *'"
            type="email"
            rounded
            dense
            outlined
            :rules="[(val) => !!val || $t('leads.required')]"
          />

          <q-select
            v-model="form.origin_country"
            :label="$t('leads.country') + ' *'"
            :options="universeStore.countries"
            rounded
            dense
            outlined
            emit-value
            map-options
            :rules="[(val) => !!val || $t('leads.required')]"
          />
          <PhoneInput
            v-model="form.phone"
            :error-text="$t('contact_info_form.phone_rule2')"
            :label="$t('leads.phone')"
            :dense="true"
            :required="false"
            @validity-change="isPhoneValid = $event"
            ref="phoneRef"
          />
          <q-input
            v-model="form.message"
            :label="$t('leads.notes')"
            type="textarea"
            rounded
            dense
            outlined
          />

          <q-input v-model="form.website_url" class="hidden-hp" tabindex="-1" />

          <q-card-actions align="right" class="q-px-none q-pt-lg">
            <q-btn :label="$t('leads.cancel')" flat rounded no-caps color="grey-7" v-close-popup />
            <q-btn
              :label="$t('leads.submit')"
              type="submit"
              rounded
              no-caps
              color="secondary"
              :loading="loading"
            />
          </q-card-actions>
        </q-form>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted } from 'vue'
import { useQuasar } from 'quasar'
import { useI18n } from 'vue-i18n'
import { useLeadStore } from 'src/stores/lead-store'
import type { LeadCreate } from 'src/types/Lead'
import PhoneInput from 'components/common/PhoneInput.vue'
import { useUniverseStore } from 'src/stores/universe-store'

const props = defineProps<{ programmeId: number }>()

const model = defineModel<boolean>({ default: false })

const { t } = useI18n()
const $q = useQuasar()
const leadStore = useLeadStore()
const universeStore = useUniverseStore()

const loading = ref(false)
const isPhoneValid = ref(false)
const phoneRef = ref()

const form = reactive<LeadCreate>({
  programme_id: props.programmeId,
  first_name: '',
  last_name: '',
  email: '',
  origin_country: '',
  phone: '',
  message: '',
  website_url: '',
})

onMounted(async () => {
  await universeStore.initCountries()
})

const onSubmit = async () => {
  if (!isPhoneValid.value) {
    phoneRef.value?.markBlurred()
    return
  }
  try {
    await leadStore.registerInterest(form)
    $q.notify({ color: 'positive', message: t('leads.success') })
    model.value = false // Κλείσιμο του dialog
  } catch {
    $q.notify({ color: 'negative', message: t('leads.error') })
  }
}
</script>

<style scoped>
.hidden-hp {
  position: absolute;
  left: -9999px;
  opacity: 0;
}
</style>
